import { createFileRoute } from "@tanstack/react-router";
import AdminSecuritySweeps from "@/pages/AdminSecuritySweeps";

export const Route = createFileRoute("/admin/security/scans/")({
  component: AdminSecuritySweeps,
});
